<template lang="pug">
div
  v-card
    v-toolbar.elevation-0(height="45" color="gray")
      v-toolbar-title.subheading {{ $t('pageHeader.appeal') }}
      Create(@created="getList(location.storeID)")
    v-card-title
      v-flex(md4)
        v-text-field(v-model='search', append-icon='search', label='Search', single-line, hide-details clearable)
      v-flex(md4)
        v-select(single-line, hide-details
          :items="comboBoxByID(26).ComboBoxDetails"
          :label="$t('labels.status')"
          item-text="selector"
          item-value="id" 
          v-model="statusID")
    v-data-table(:headers='headers' item-key="id" :items='appeals' :search="search" :loading='loading' :pagination.sync='pagination')
      template(slot='items' slot-scope='props')
        tr.pointer
          td.text-xs-left
            Status(:statusID="props.item.statusID" :name="props.item.appealStatusDetail.selector")
          td.text-xs-left {{ props.item.invoiceDate | moment("MM/DD/YYYY") }}
          td.text-xs-left {{ props.item.phoneName }}
          td.text-xs-left {{ props.item.phoneNumber }}
          td.text-xs-left {{ props.item.IMEINumber }}
          td.text-xs-left {{ props.item.appealFor }}
          td.text-xs-right {{ props.item.amount | currency }}
          td.justify-end.layout.px-0
            v-menu(bottom, left offset-y)
              v-btn(slot='activator', icon)
                v-icon more_vert
              v-list.menu-button
                ViewAppeal(:appealValue="props.item" @created="getList(location.storeID)")
                v-divider
                MarkedAppeal(:appealValue="props.item" @created="getList(location.storeID)")
                GotPaid(:appealValue="props.item" @created="getList(location.storeID)")                
                Edit(:editValue="props.item" @created="getList(location.storeID)")
                v-list-tile(@click='removeAppeal(props.item)')
                  v-list-tile-title {{ $t('buttons.delete') }}
      v-alert(slot='no-results', :value='true', color='error', icon='warning')
        | Your search for "{{ search }}" found no results.
</template>

<script>
import appealService from "../service.js"
import Status from "./StatusComponent"
import { mapGetters } from 'vuex';
// const Status = () => import('./StatusComponent')
const Create = () => import('./Create')
const Edit = () => import('./Edit')
const MarkedAppeal = () => import('./MarkedAppeal')
const GotPaid = () => import('./GotPaid')
const ViewAppeal = () => import('./ViewAppeal')

export default {
  data() {
    return {
      statusID: 0,
      editValue: null,
      editDialog: false,
      appeals: [],
      headers: [
        {
          text: this.$t("labels.status"),
          value: "appealStatusDetail.selector",
          sortable: true,
        },
        {
          text: this.$t("labels.invoiceDate"),
          value: "invoiceDate",
          sortable: true,
        },
        {
          text: this.$t("labels.phoneName"),
          value: "phoneName",
          sortable: true
        },
        {
          text: this.$t("labels.phoneNumber"),
          value: "phoneNumber",
          sortable: true,
        },
        {
          text: this.$t("labels.imeiNumber"),
          value: "IMEINumber",
          sortable: true,
        },
        {
          text: this.$t("labels.appealFor"),
          value: "appealFor",
          sortable: true,
        },
        {
          text: this.$t("labels.amount"),
          value: "amount",
          sortable: true,
        },
        {
          text: "",
          value: "action",
          sortable: false
        }
      ],
      search: null,
      loading: true,
      pagination: {
        rowsPerPage: 10,
        sortBy: "invoiceDate",
        descending: true
      }
    };
  },
  components: {
    Create,
    Status,
    Edit,
    GotPaid,
    ViewAppeal,
    MarkedAppeal,
  },
  computed: {
    ...mapGetters("global", ["comboBoxByID", "currentUser"]),
    ...mapGetters('location', ['location'])
  },
  watch: {
    statusID() {
      this.getList(this.location.storeID)
    }
  },
  async created() {
    this.comboBoxByID(26).ComboBoxDetails.push({id: 0, selector: 'All'})
    await this.getList(this.location.storeID)
  },
  methods: {
    removeAppeal(data) {
      this.$swal({
        title: 'Are you sure?',
        text: "You won't be able to revert this!",
        type: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Yes, delete it!',
      }).then((result) => {
        if (result.value) {
          this.$Progress.start()
          return appealService.delete(data.id).then((response) => {
            if (response.data) {
              this.$swal.mixin({
              toast: true,
              position: 'top-end',
              showConfirmButton: false,
              timer: 3000
              }).fire({
                type: 'success',
                title: 'Appeal has been deleted'
              })
              this.$Progress.finish()
              this.getList(this.location.storeID);
            }
          }).catch((error) => {
            this.$swal.mixin({
              toast: true,
              position: 'top-end',
              showConfirmButton: false,
              timer: 3000
            }).fire({
              type: 'error',
              title: err.data.message
            })
            this.$Progress.fail()
          })
        }
      })
    },
    getList(id) {
      this.loading = true;
      appealService.getAll(id, {status: this.statusID}).then(response => {
        console.log("appealService response", response);
        this.appeals = response.data.rows;
        this.loading = false;
      });
    }
  }
}
</script>

<style scoped>
</style>